module.exports = __webpack_public_path__ + "static/media/icon-supplies.04bba62c.svg";